import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetArticlesParams = Required<operations['ArticleController_findAll']['parameters']>['query']

/**
 * 콘텐츠(아티클) 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param categoryId 콘텐츠 카테고리 id
 * @returns ResListArticle
 */
export const getArticles = async ({ size = 50, offset = 0, categoryId }: GetArticlesParams) => {
  return (
    await axios.get<components['schemas']['ResListArticle']>('/article', { params: { size, offset, categoryId } })
  ).data
}

/**
 * 콘텐츠 카테고리 목록
 * @returns ResListArticleCategory
 */
export const getArticleCategories = async () => {
  return (await axios.get<components['schemas']['ResListArticleCategory']>('/article/category')).data
}

/**
 * 콘텐츠 상세 정보
 * @param articleId 콘텐츠 id
 * @returns ArticleDto
 */
export const getArticleDetail = async (articleId: number) => {
  return (await axios.get<components['schemas']['ArticleDto']>(`/article/${articleId}`)).data
}
